<template >
  <div>
    <v-toolbar color="white" height="53" dark style="box-shadow: none;">
      <div class="buscador">
        <v-btn icon style="margin-left: 25px !important;">
          <v-icon medium color="#d3d7eb" class="menu_buscador">search</v-icon>
        </v-btn>
        <v-text-field
          flat
          solo-inverted
          placeholder="Búsqueda general"
          color="#989EB9"
          class="hidden-sm-and-down"
          @keyup.enter="buscador()"
          v-model.lazy="search"
          autocomplete="off"
          id="buscador"
          :class="clase"
          style="height: 80% !important; margin-left: 0px !important; margin-top: 20px !important;"
        ></v-text-field>
      </div>

      <div class="faq">
        <span class="faq-text">¿Tienes dudas?</span>
        <i class="material-icons faq-icon">help_outline</i>
      </div>

      <v-menu offset-y origin="center" :nudge-bottom="18" :nudge-left="90" transition="slide-y">
        <template v-slot:activator="{on}">
          <div class="notifications" v-on="on">
            <i class="material-icons notification-icon">notifications_none</i>
            <span class="badge" v-if="notificationsNew.length > 0">{{ notificationsNew.length }}</span>
          </div>
        </template>
        <notification-list
          :notifications="notificationsNew"
          @updateNotifications="loadNotificaciones"
        ></notification-list>
      </v-menu>

      <v-menu offset-y origin="center" :nudge-bottom="18" transition="slide-y">
        <template v-slot:activator="{on}">
          <div class="user" v-on="on">
            <img :src="usuario.foto_url" alt="Profile Photo" class="user-image" />
            <span class="user-name">{{ usuario_nombre }}</span>
            <i class="material-icons user-icon">expand_more</i>
          </div>
        </template>

        <div class="profile-menu-panel">
          <div class="profile-menu-content">
            <div
              class="profile-menu-item"
              v-for="item in items"
              :key="item.title"
              @click="_logout(item.title)"
            >
              <span>
                <v-icon class>{{ item.icon }}</v-icon>
              </span>
              <span class="opciones">{{ item.title }}</span>
            </div>
          </div>
        </div>
      </v-menu>
    </v-toolbar>

    <template v-if="modal_perfil">
      <v-layout row justify-center>
        <v-dialog v-model="modal_perfil" persistent :max-width="max_width">
          <v-btn slot="activator" class="d-none d-lg-block" id="btnmodal"></v-btn>
          <v-card>
            <v-card-title>
              <span class="headline" v-text="titulo_modal"></span>
            </v-card-title>
            <v-card-text>
              <v-container grid-list-md id="contenedor" key="unique">
                <v-layout wrap>
                  <template v-if="accion == 'perfil'">
                    <v-layout wrap>
                      <v-flex xs12 sm12 md12>
                        <v-list two-line class="transparente">
                          <v-list-tile>
                            <v-list-tile-avatar>
                              <img :src="usuario.foto_url" alt="Empleado" />
                            </v-list-tile-avatar>
                            <v-list-tile-content>
                              <v-list-tile-title
                                class="tipoLetra700Azul transparente"
                              >{{ usuario.nombre + ' ' + usuario.apellido_paterno + ' ' + usuario.apellido_materno }}</v-list-tile-title>
                              <v-list-tile-sub-title class="tipoletra400Gris">{{ usuario.email }}</v-list-tile-sub-title>
                            </v-list-tile-content>
                          </v-list-tile>
                        </v-list>
                      </v-flex>
                    </v-layout>

                    <v-layout wrap>
                      <v-flex xs12 sm4 md4>
                        <v-text-field
                          disabled
                          label="Puesto"
                          class="tipoLetra"
                          v-model="usuario.puesto"
                        >
                          <template slot="prepend-inner">
                            <v-icon class="tamIcono invertirColor">work</v-icon>
                            <v-icon class="fa-rotate-270 pt-3 iconoDelgado">maximize</v-icon>
                          </template>
                        </v-text-field>
                      </v-flex>

                      <v-flex xs12 sm4 md4>
                        <v-text-field
                          disabled
                          label="Teléfono"
                          class="tipoLetra"
                          v-model="usuario.telefono"
                          mask="phone"
                        >
                          <template slot="prepend-inner">
                            <v-icon class="tamIcono invertirColor">phone</v-icon>
                            <v-icon class="fa-rotate-270 pt-3 iconoDelgado">maximize</v-icon>
                          </template>
                        </v-text-field>
                      </v-flex>
                    </v-layout>
                  </template>

                  <template v-if="accion == 'cambio_contraseña'">
                    <v-flex xs12 sm12 md12>
                      <v-text-field
                        label="Contraseña anterior"
                        type="password"
                        v-model="usuario.password"
                        @keyup.enter="verificar('password_anterior')"
                      ></v-text-field>
                    </v-flex>
                    <template v-if="aprovo_password">
                      <span class="v-stepper__step__step" color="red">
                        <i
                          class="v-icon fa fa fa fa-exclamation-triangle theme--light"
                          style="color:red;"
                        ></i>
                      </span>
                      <div class="v-stepper__label" style="color:red;">Contraseña Incorrecta</div>
                    </template>
                  </template>

                  <template v-if="accion == 'cambio_password'">
                    <v-flex xs12 sm12 md12>
                      <v-text-field
                        label="Nueva contraseña"
                        type="password"
                        v-model="nuevo_password"
                        id="nuevo_password"
                        v-validate="'required|verify_password'"
                        data-vv-name="contraseña"
                        :error-messages="errors.collect('contraseña')"
                        auto
                        required
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 md12>
                      <v-text-field
                        label="Confirmar la contraseña"
                        type="password"
                        v-model="confirmacion"
                        id="verificar_password"
                        v-validate="'required|verify_password'"
                        data-vv-name="confirmación"
                        :error-messages="errors.collect('confirmación')"
                        auto
                        required
                        @keyup.enter="verificar('confirmacion')"
                      ></v-text-field>
                    </v-flex>
                    <template v-if="password_igual">
                      <div
                        class="v-stepper__label"
                        style="color:red;"
                      >Las contraseñas no son iguales, favor de verificar.</div>
                    </template>
                  </template>

                  <template v-if="accion == 'cambio_logo'">
                    <v-flex xs12 sm12 md12>
                      <v-text-field
                        readonly
                        class="pt-0 mt-0"
                        label="Seleccionar una foto..."
                        @click="almacenarImagen"
                        v-model="nombreImagen"
                      >
                        <template slot="prepend-inner">
                          <v-icon class="tamIcono">attach_file</v-icon>
                          <v-icon class="fa-rotate-270 pt-3 iconoDelgado">maximize</v-icon>
                        </template>
                      </v-text-field>
                      <input
                        type="file"
                        style="display: none"
                        ref="imagen"
                        accept="image/*"
                        id="avatar"
                        @change="onFilePickedImagen"
                      />
                    </v-flex>
                  </template>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" flat @click="cerrarModal()">Cerrar</v-btn>
              <v-btn
                color="blue darken-1"
                v-if="accion == 'cambio_logo'"
                flat
                @click="guardarImagen()"
              >Guardar</v-btn>
              <v-btn
                color="blue darken-1"
                v-if="accion == 'cambio_contraseña'"
                flat
                @click="verificar('password_anterior')"
              >Verificar</v-btn>
              <v-btn
                color="blue darken-1"
                v-if="accion == 'cambio_password'"
                flat
                @click="verificar('confirmacion')"
              >Guardar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
    </template>
  </div>
</template>

<script>
import NotificationList from "@/components/widgets/list/NotificationList";
import Util from "@/util";
import { mapActions, mapState } from "vuex";
import io from "socket.io-client";
import VWidget from "@/components/VWidget";
import Swal from "sweetalert2";
import Notify from "@/plugins/notify";
import userApi from "../api/usuarios";
import SocketService from "@/plugins/socket-host";
import GetUrlImg from "@/plugins/Urlimagen";
import notificacionesApi from "../api/notificaciones";
import clienteApi from "../api/clientes";

export default {
  name: "app-toolbar",
  components: {
    NotificationList,
    VWidget
  },
  props: {
    notification: {
      type: Array,
      default: () => []
    }
  },
  data: () => ({
    socket: {},
    clase: "v-input--is-focused",
    items: [
      {
        icon: "account_circle",
        href: "#",
        title: "Perfil",
        click: e => {
          window.getApp.this._logout();
        }
      },
      {
        icon: "settings",
        href: "#",
        title: "Cambiar contraseña",
        click: e => {
          this.cambiar_contraseña();
        }
      },
      {
        icon: "power_settings_new",
        href: "#",
        title: "Salir",
        click: e => {
          window.getApp.this._logout();
        }
      }
    ],
    max_width: "",
    search: "",
    modal_perfil: false,
    titulo_modal: "",
    accion: "",
    usuario: {
      id: 0,
      nombre: "",
      apellido_paterno: "",
      apellido_materno: "",
      puesto: "",
      email: "",
      fecha_nacimiento: "",
      telefono: "",
      celular: "",
      password: "",
      primer_inicio_sesion: "",
      rol_id: "",
      foto_url: ""
    },
    rol_nombre: "",
    nuevo_password: "",
    confirmacion: "",
    aprovo_password: false,
    password_igual: false,
    user_vuex: {
      email: "",
      password: ""
    },
    usuario_nombre: "",
    id_usuario: null,
    notificaciones: [],
    ImgUrl: null,
    nombreImagen: "",
    archivoImagen: null
  }),
  watch: {
    search: function(value) {
      if (value == "") {
        setTimeout(
          () => $(".v-label.theme--dark").css({ color: "#989EB9" }),
          1
        );
      }
    },
    notification: {
      handler: function() {
        if (this.notification.length > 0) {
          this.notificaciones = this.notification;
          this.emitEvent();
        } else {
          this.notificaciones = this.notification;
        }
      }
    }
  },
  computed: {
    ...mapState("auth", ["datos", "user", "foto_usr", "error", "menu"]),
    toolbarColor() {
      return this.$vuetify.options.extra.mainNav;
    },
    notificationsNew() {
      return this.notificaciones.filter(item => item.activo);
    }
  },
  methods: {
    ...mapActions("auth", ["logout", "update_password", "updateUserData"]),
    async _logout(tipo) {
      switch (tipo) {
        case "Perfil":
          this.ver_perfil();
          break;
        case "Cambiar contraseña":
          this.cambiar_contraseña();
          break;
        case "Cambiar logo":
          this.cambiar_logo();
          break;
        case "Salir":
          await this.logout();
          this.$router.push("/");
          break;
      }
    },
    handleDrawerToggle() {
      window.getApp.$emit("APP_DRAWER_TOGGLED");
    },
    buscador() {
      var datosLogin = this.$session.get("usuario");
      let rol = datosLogin.rol.name;
      if (this.search != "") {
        if (rol != "checador") {
          this.$router.push("/buscador/" + this.search);
        }
      }
    },
    ver_perfil() {
      var datosLogin = this.$session.get("usuario");

      if (datosLogin.rol.name == "empleado") {
        this.$router.push(
          "/empleado/detalleEmpleado/" +
            window.btoa(this.$session.get("empleado").id)
        );
      } else {
        this.modal_perfil = true;
        this.max_width = "700px";
        this.titulo_modal = "Mi perfil";
        this.accion = "perfil";
        this.llena_datos();
      }
    },
    llena_datos() {
      this.usuario.id = this.datos.id;
      this.usuario.nombre = this.datos.nombre;
      this.usuario.apellido_paterno = this.datos.apellido_paterno;
      this.usuario.apellido_materno = this.datos.apellido_materno;
      this.usuario.puesto = this.datos.puesto;
      this.usuario.email = this.datos.email;
      this.usuario.telefono = this.datos.telefono;
      this.usuario.celular = this.datos.celular;
      this.rol_nombre = this.datos.rol.display_name;
      this.usuario.rol_id = this.datos.rol.id;
      this.usuario.primer_inicio_sesion = false;
      this.usuario.password = this.confirmacion;
      this.user_vuex.email = this.usuario.email;
      this.user_vuex.password = this.confirmacion;
      this.usuario.fecha_nacimiento = "";

      if (this.datos.fecha_nacimiento != null) {
        this.usuario.fecha_nacimiento = this.datos.fecha_nacimiento.replace(
          /^(\d{4})-(\d{2})-(\d{2})$/g,
          "$3/$2/$1"
        );
      }
    },
    cerrarModal() {
      this.modal_perfil = false;
      this.resetValue();
    },
    async update() {
      this.llena_datos();
      this.usuario.fecha_nacimiento = this.datos.fecha_nacimiento;

      await this.update_password(this.user_vuex);
      await userApi
        .updatePassword(this.usuario)
        .then(response => {
          this.cerrarModal();
          Swal.fire("Actualizado", "Los datos se han actualizado.", "success");
        })
        .catch(err => {
          Swal.fire({
            position: "center",
            type: "error",
            title: "Error",
            text: error.response.data.message,
            showConfirmButton: true
          });
        });
    },
    verificar(tipo) {
      var self = this;
      if (tipo === "confirmacion") {
        if (this.confirmacion == this.nuevo_password) {
          this.password_igual = false;
          this.update();
        } else {
          this.password_igual = true;
        }
      } else if (tipo === "password_anterior") {
        this.$validator.validate().then(result => {
          if (result) {
            if (self.usuario.password === this.user.password) {
              this.accion = "cambio_password";
              this.aprovo_password = false;
              setTimeout(function() {
                document.getElementById("nuevo_password").focus();
              }, 100);
            } else {
              this.aprovo_password = true;
            }
          }
        });
      }
    },
    cambiar_contraseña() {
      this.modal_perfil = true;
      this.max_width = "400px";
      this.accion = "cambio_contraseña";
      this.titulo_modal = "Cambio de contraseña";
    },
    cambiar_logo() {
      this.modal_perfil = true;
      this.max_width = "400px";
      this.accion = "cambio_logo";
      this.titulo_modal = "Cambio de logo";
    },
    guardarImagen() {
      var datosLogin = this.$session.get("usuario");
      let formData = new FormData();
      let self = this;

      var update = false;
      formData.append("cliente_id", datosLogin.cliente_id);
      if (this.archivoImagen != null) {
        formData.append("archivo", this.archivoImagen);
        if (datosLogin.foto_empresa != null) {
          formData.append("update_logo", datosLogin.foto_empresa);
          update = true;
        }
      }
      formData.append("update", update);

      clienteApi
        .updateLogo(formData)
        .then(response => {
          this.respuesta_ok();
          var data = {
            usuario_id: datosLogin.id,
            sistema: 'gdth'
          };
          self.update_logo(data);
        })
        .catch(err => {
          this.respuesta_error(err);
        });
    },
    async update_logo(data) {
      await this.updateUserData(data);
      if (!this.error) {
        this.$session.destroy();

        this.$session.set("usuario", this.datos);
        this.$session.set("menu", this.menu);
      }
    },
    almacenarImagen() {
      this.$refs.imagen.click();
    },
    onFilePickedImagen(evento) {
      const img = evento.target.files;
      if (img[0] !== undefined) {
        this.nombreImagen = img[0].name;
        if (this.nombreImagen.lastIndexOf(".") <= 0) {
          return;
        }
        const archivo = new FileReader();
        archivo.readAsDataURL(img[0]);
        archivo.addEventListener("load", () => {
          this.archivoImagen = img[0];
        });
      } else {
        this.nombreImagen = "";
        this.archivoImagen = null;
      }
    },
    resetValue() {
      this.usuario.id = 0;
      this.usuario.nombre = "";
      this.usuario.apellido_paterno = "";
      this.usuario.apellido_materno = "";
      this.usuario.titulo = "";
      this.usuario.puesto = "";
      this.usuario.email = "";
      this.usuario.fecha_nacimiento = "";
      this.usuario.telefono = "";
      this.usuario.telefono_oficina = "";
      this.usuario.extension = "";
      this.usuario.celular = "";
      this.rol_nombre = "";
      this.usuario.password = "";
      this.usuario.primer_inicio_sesion = "";
      this.modal_perfil = false;
      this.titulo_modal = "";
      this.accion = "";
      this.nuevo_password = "";
      this.confirmacion = "";
      this.aprovo_password = false;
      this.password_igual = false;
      this.nombreImagen = "";
      this.archivoImagen = null;
    },
    emitEvent() {
      this.notification.forEach(item => {
        this.socket.emit("new-notification", {
          usuario_id: item.receptor_usuario_id,
          modulo: item.modulo,
          titulo: item.titulo,
          descripcion: item.descripcion,
          token_movil: item.token_movil
        });
      });
    },
    loadNotificaciones() {
      notificacionesApi
        .getNotificaciones({
          usuario_id: this.id_usuario,
          activo: true,
          paginate: false
        })
        .then(response => {
          this.notificaciones = response.data;
        })
        .catch(error => {
          Notify.ErrorToast(error.response.data.error);
        });
    },
    respuesta_error(error) {
      console.log(error);
      Swal.fire({
        position: "center",
        type: "error",
        title: "Error",
        text: error.response.data.message,
        showConfirmButton: true
      });
    },
    respuesta_ok() {
      this.cerrarModal();
      Swal.fire({
        position: "center",
        type: "success",
        title: "Operación exitosa",
        showConfirmButton: true
      });
    }
  },
  mounted() {
    var datosLogin = this.$session.get("usuario");

    if (datosLogin != undefined) {
      this.usuario_nombre =
        datosLogin.nombre + " " + datosLogin.apellido_paterno;
      this.id_usuario = datosLogin.id;

      this.loadNotificaciones();
    }

    if (datosLogin.rol.name == "admin") {
      this.items.push({
        icon: "account_circle",
        href: "#",
        title: "Cambiar logo",
        click: e => {
          this.cambiar_logo();
        }
      });
    }

    $(".v-label.theme--dark").css({ color: "#989EB9" });
    $("#buscador").css({ color: "#989EB9" });
    $(".v-menu__content").css({ "box-shadow": "none" });

    this.socket.on("new-notification", data => {
      if (this.id_usuario == data.usuario_id) {
        this.loadNotificaciones();
      }
    });
  },
  created() {
    this.socket = io(SocketService.getHost());

    this.ImgUrl = GetUrlImg.getURL();
    this.usuario.foto_url = "/static/avatar/usuario4.jpg";

    if (
      this.ImgUrl != null &&
      this.ImgUrl != "" &&
      this.ImgUrl != undefined &&
      this.foto_usr != "" &&
      this.foto_usr != null &&
      this.foto_usr != undefined
    ) {
      this.usuario.foto_url = this.ImgUrl + this.foto_usr;
    }
  }
};
</script>

<style scoped>
.v-label.theme--dark {
  color: #989eb9 !important;
}

.buscador {
  width: 70%;
  display: flex;
}

.faq {
  padding-left: 15px;
  padding-right: 15px;
  border-left: 1px solid #f2f3f8;
  /* width: 15%; */
  display: flex;
  align-items: center;
}
.faq .faq-text {
  color: #848bab;
  font-family: Montserrat;
  font-size: 14px;
  font-weight: 400;
  line-height: 17px;
  text-align: left;
  margin-right: 10px;
}
.faq .faq-icon {
  color: rgb(216, 219, 237);
  font-size: xx-large;
}

.notifications {
  padding-left: 15px;
  padding-right: 15px;
  border-left: 1px solid #f2f3f8;
  /* width: 10%; */
  display: flex;
  align-items: center;
}
.notification-icon {
  color: rgb(216, 219, 237);
  font-size: xx-large;
  margin-right: 10px;
}
.notifications .badge {
  background-color: #ff9e1a;
  border-radius: 100%;
  width: 18px;
  height: 18px;
  position: absolute;
  top: 5px;
  margin-left: 25px;
  color: #ffffff;
  font-weight: 400;
  text-align: center;
}

.user {
  padding-left: 15px;
  border-left: 1px solid #f2f3f8;
  /* width: 15%; */
  display: flex;
  align-items: center;
}
.user-name {
  color: #9fa5be;
  font-family: "Montserrat";
  font-size: 14px;
  font-weight: 400;
  line-height: 17px;
  text-align: left;
}
.user-image {
  float: left;
  width: 35px;
  height: 35px;
  border-radius: 50%;
  margin-right: 10px;
  margin-top: -2px;
}
.user-icon {
  color: rgb(216, 219, 237);
}

.profile-menu-panel {
  background-color: #ffffff;
  border: 1px solid #eff1fb;
  border-radius: 3px;
  box-shadow: 0 2px 12px 0 rgba(129, 158, 200, 0.06);
  overflow: auto;
  width: 240px;
  min-width: 112px;
  max-width: 280px;
  min-height: 64px;
  max-height: calc(100vh - 48px);
}
.profile-menu-content:not(:empty) {
  padding-top: 8px;
}
div.profile-menu-item {
  width: 100%;
  user-select: none;
  cursor: pointer;
  outline: 0;
  /*  border: none; */
  border-bottom-width: 1px;
  border-bottom-style: solid;
  border-color: #eff1fb;
  -webkit-tap-highlight-color: transparent;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
  height: 41px;
  padding: 0 16px;
  padding-top: 10px;
  max-width: 100%;
  position: relative;

  color: #0f3043;
  font-family: "Montserrat";
  font-size: 13px;
  font-weight: 400;
  line-height: 16px;
  text-align: left;
}
div.profile-menu-item:first-child {
  border-bottom: 1px solid #eff1fb;
}

.v-text-field--solo-inverted {
  margin-left: 3% !important;
}

.icono_menu {
  margin-right: 30px;
}
.icono_notificacion {
  margin-right: 30px;
}
.menu_buscador {
  color: rgb(39, 8, 88);
  margin-top: 35px !important;
  z-index: 3;
  padding-right: 15px;
  border-right: 1px solid #f2f3f8;
  margin-top: 20px;
}
#contenedor {
  margin-top: -4%;
}
.nombre {
  color: black;
}
.v-avatar {
  margin-right: 15px !important;
}
#fondo_rojo {
  left: 45% !important;
}
.opciones {
  padding-left: 20px;
  border: #0f3043;
  border-width: 1;
}
</style>